import { render, staticRenderFns } from "./JsMenu.vue?vue&type=template&id=7a37e529&scoped=true&"
import script from "./JsMenu.vue?vue&type=script&lang=js&"
export * from "./JsMenu.vue?vue&type=script&lang=js&"
import style0 from "./JsMenu.vue?vue&type=style&index=0&id=7a37e529&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a37e529",
  null
  
)

export default component.exports